import { Grid, Typography } from '@mui/material';
import { Container } from '@mui/system';
import globals from '../globals';
import RedButton from '../components/redButton';
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PasswordField from '../components/login/password_tf';


const ChangePass = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [showMessage, setShowMessage] = useState(false);
    const [passwordValue, setPasswordValue] = useState('');
    const [confirmPasswordValue, setConfirmPasswordValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [tokenValid, setTokenValid] = useState(null);
    const [token, setToken] = useState('');

    // Validate token on component mount
    useEffect(() => {
        const tokenFromUrl = searchParams.get('token');
        if (tokenFromUrl) {
            setToken(tokenFromUrl);
            validateToken(tokenFromUrl);
        } else {
            setTokenValid(false);
            setErrorMessage('Невалиден линк за смяна на парола');
        }
    }, [searchParams]);

    const validateToken = async (tokenToValidate) => {
        try {
            const response = await fetch(`${globals.apiUrl}/auth/validate-reset-token/${tokenToValidate}`);
            if (response.ok) {
                const data = await response.json();
                setTokenValid(data.valid);
                if (!data.valid) setErrorMessage('Линкът за смяна на парола е невалиден или изтекъл');
            } else {
                setTokenValid(false);
                setErrorMessage('Линкът за смяна на парола е невалиден или изтекъл');
            }
        } catch (error) {
            setTokenValid(false);
            setErrorMessage('Възникна грешка при проверката на линка');
        }
    };

    const handlePassChange = (e) => {
        setPasswordValue(e.target.value);
        setErrorMessage(''); // Clear error when user types
    };

    const handleConfirmPassChange = (e) => {
        setConfirmPasswordValue(e.target.value);
    };

    const handleSubmit = async () => {
        if (passwordValue.trim() === '' || confirmPasswordValue.trim() === '') {
            return; // Don't submit if passwords are empty
        }
        if (passwordValue !== confirmPasswordValue) {
            return; // Don't submit if passwords don't match
        }
        if (!tokenValid || !token) {
            setErrorMessage('Невалиден токен за смяна на парола');
            return;
        }

        setIsLoading(true);
        setErrorMessage('');

        try {
            const response = await fetch(`${globals.apiUrl}/auth/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                    new_password: passwordValue
                })
            });

            if (response.ok) {
                setShowMessage(true);
                // Redirect to login page after showing success message
                setTimeout(() => {
                    navigate('/login');
                }, 2000); // Wait 2 seconds before redirecting
            } else {
                setErrorMessage('Възникна грешка при смяната на паролата');
            }
        } catch (error) {
            setErrorMessage('Възникна грешка при свързване със сървъра');
        } finally {
            setIsLoading(false);
        }
    }

    // Helper text for password mismatch
    const getPasswordMismatchText = () => {
        if (confirmPasswordValue && passwordValue && passwordValue !== confirmPasswordValue) {
            return "Паролите не съвпадат";
        }
        return "";
    }

    // Show loading state while validating token
    if (tokenValid === null) {
        return (
            <Container>
                <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh' }}>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 17 }}>Проверяване на линка...</Typography>
                </Grid>
            </Container>
        );
    }

    // Show error if token is invalid
    if (tokenValid === false) {
        return (
            <Container>
                <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh' }}>
                    <Grid item>
                        <Typography sx={{ color: globals.colors.darkRed, fontSize: 17, fontWeight: 'bold', textAlign: 'center' }}>
                            {errorMessage}
                        </Typography>
                        <Typography sx={{ color: globals.colors.gray, fontSize: 14, textAlign: 'center', mt: 2 }}>
                            Моля, заявете нов линк за смяна на парола.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        );
    }

    return (
        <Container>
            <Grid container direction={'column'}>
                <Grid item>
                    <Typography sx={{ color: globals.colors.lightRed, fontSize: 17, fontWeight: 'bold' }} >Смяна на забравена парола</Typography>
                </Grid>
                <Grid item sx={{ mt: 3 }}>
                    <PasswordField onChange={handlePassChange} />
                </Grid>
                <Grid item sx={{ mt: 3 }}>
                    <PasswordField
                        label={'Потвърди паролата'}
                        onChange={handleConfirmPassChange}
                        helperText={getPasswordMismatchText()}
                    />
                </Grid>
                <Grid item sx={{ mt: 3 }}>
                    <RedButton
                        onClick={handleSubmit}
                        sx={{ mx: 5, my: 1 }}
                        disabled={passwordValue.trim() === '' || confirmPasswordValue.trim() === '' || passwordValue !== confirmPasswordValue}
                        text={"Промени"} />
                </Grid>
                {showMessage && <Typography sx={{ color: globals.colors.lightRed }}>Успешно сменена парола! Препращане към "Вход".</Typography>}
            </Grid>
        </Container>
    );
}

export default ChangePass
